import type { IntlShape } from 'react-intl';
import { STATUS } from 'receivable-invoices-js/constants/invoices';
import type { ReceivableInvoice } from 'receivable-invoices-js/react/api/models/receivable-invoice';

export const getInvoiceStatus = (invoice: ReceivableInvoice, intl: IntlShape) => {
  const { formatMessage } = intl;
  switch (invoice.status) {
    case STATUS.DRAFT:
      return {
        level: 'inactive' as const,
        text: formatMessage({ id: 'invoice.preview.draft.badge' }),
      };
    case STATUS.PAID:
      return {
        level: 'validated' as const,
        text: formatMessage({ id: 'invoice.preview.paid' }),
      };
    case STATUS.UNPAID:
      return {
        level: 'in-progress' as const,
        text: formatMessage({ id: 'invoice.preview.unpaid' }),
      };
    default:
      return { level: 'inactive' as const, text: '' };
  }
};
